import crypto from 'crypto';

// 判断设备类型
export function userAgentType() {
  let ua = navigator.userAgent;
  console.log(ua);
  let isWindowsPhone = /(?:Windows Phone)/.test(ua);
  let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone;
  let isAndroid = /(?:Android)/.test(ua);
  let isIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  let isFireFox = /(?:Firefox)/.test(ua);
  let isTablet = /(?:iPad|PlayBook)/.test(ua)
      || (isAndroid && !/(?:Mobile)/.test(ua))
      || (isFireFox && /(?:Tablet)/.test(ua));
  let isPhone = /(?:iPhone)/.test(ua) && !isTablet;
  let isPc = !isPhone && !isAndroid && !isSymbian;
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
    isIos,
  };
}

// 判断是否是松鼠APP
export function isSSAI() {
  return /SSAI_Android|SSAI_iOS$/.test(navigator.userAgent);
}

// 调用函数

export function jsBridgeForSSAI(action, params, callback) {
  let ua = navigator.userAgent;
  let data = {
    action,
    params: params || {},
    callback: callback || '',
  };
  data = JSON.stringify(data);
  if (/SSAI_Android$/.test(ua)) {
    window.ssaiAppJS.postMessage(data);
  } else {
    window.webkit.messageHandlers.ssaiAppJS.postMessage(data);
  }
}

export function getStamp() {
  const timeStamp = Date.parse(new Date()) / 1000;
  // console.log(timeStamp);
  return timeStamp;
}
export function getRandom(num) {
  /* eslint-disable */
  let random = Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, num - 1));
  return random;
  /* eslint-enable */
}
export function isObject(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object object]') {
    return true;
  }
  return false;
}

export function keySort(obj) {
  const newkey = Object.keys(obj).sort();
  const newObj = {};
  for (let i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = obj[newkey[i]];
  }
  return newObj;
}

export function detectOS() {
  const sUserAgent = navigator.userAgent;
  const isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows');
  const isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel');
  if (isMac) return 'MacOs';
  if (isWin) {
    return 'Windows';
  }
  const agentType = userAgentType();
  if (agentType.isTablet) {
    return 'PadOs';
  }
  if (agentType.isPhone) {
    return 'IOS';
  }
  if (agentType.isAndroid) {
    return 'Android';
  }
  return 'Web';
}

// 应用类型
export function getAppType() {
  if (isSSAI()) {
    return 'ssai_app';
  }
  return 'H5';
}

export function getSign(obj) {
  if (typeof obj.sign !== 'undefined') {
    delete obj.sign;
  }
  const temp = keySort(obj);
  let appkey = '';
  if (window.location.href.indexOf('exp4pad.classba.cn') > -1) {
    appkey = 'RrA3N3Qytd7mV8nQ6kxIWo2NSRMf5TSF';
  } else {
    appkey = 'zbwe7U8lVhDVgXSI2uSFjPOT7XPNm19K';
  }

  let protoSign = '';
  /* eslint-disable */
  for (let d in temp) {
    protoSign += d + '=' + temp[d] + '&';
    // }
  }
  /* eslint-enable */
  protoSign = protoSign.substring(0, protoSign.length - 1);
  protoSign += appkey;
  const md5 = crypto.createHash('md5');
  md5.update(protoSign);
  let sign = md5.digest('hex');
  return sign;
}

export function getSpadSign() {
  let protoSign = 'eWnIx3SCTRopyYi2' + getStamp();
  const md5 = crypto.createHash('md5');
  md5.update(protoSign);
  let sign = md5.digest('hex');
  return sign;
}

// 数据埋点
export function gioPoint(event, commonParams, extraParams) {
  let {
    deviceVersion, osVersion, appVersion, fromURI, fromPageName, curURI, curPageName,
    userId, userName, accountId, duration,
  } = commonParams;
  let gioParams = {
    deviceVersion,
    osVersion,
    appVersion,
    fromURI,
    fromPageName,
    curURI,
    curPageName,
    userId,
    userName,
    accountId,
    duration,
  };
  /* eslint-disable */
  gio('track', event, Object.assign({}, gioParams, extraParams));
  /* eslint-enable */
}

export function getQueryString(name) {
  let search = window.location.href.split('?')[1];
  if (search) {
    let params = search.split('&');
    let obj = {};

    for (let i = 0, l = params.length; i < l; i++) {
      let tmp = params[i].split('=');
      obj[tmp[0]] = tmp[1];
    }

    return obj[name] || '';
  }
  return '';
}

/**
 * 微信小程序上传图片
 * @param {微信签名等信息} data
 * @param {配置内容} imageData
 */
export function imageUploadInterface(data, imageData) {
  const resArray = [];
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: data.appId, // 必填，公众号的唯一标识
    timestamp: data.timestamp, // 必填，生成签名的时间戳
    nonceStr: data.noncestr, // 必填，生成签名的随机串
    signature: data.signature, // 必填，签名
    jsApiList: ['chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getLocalImgData'], // 必填，需要使用的JS接口列表
    success: () => { },
  });
  wx.ready(() => {
    // 拍照或从手机相册中选图接口
    wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      success(res) {
        resArray.push(JSON.stringify(res.localIds));
        // var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
      },
    });

    // 预览图片接口
    wx.previewImage({
      current: '', // 当前显示图片的http链接
      urls: [], // 需要预览的图片http链接列表
    });

    // 上传图片接口
    wx.uploadImage({
      localId: '', // 需要上传的图片的本地ID，由chooseImage接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success(res) {
        resArray.push(JSON.stringify(res.serverId));
        // var serverId = res.serverId; // 返回图片的服务器端ID
      },
    });

    // 下载图片接口
    wx.downloadImage({
      serverId: '', // 需要下载的图片的服务器端ID，由uploadImage接口获得
      isShowProgressTips: 1, // 默认为1，显示进度提示
      success(res) {
        let localId = res.localId; // 返回图片下载后的本地ID
      },
    });

    // 获取本地图片接口
    wx.getLocalImgData({
      localId: '', // 图片的localID
      success(res) {
        let localData = res.localData; // localData是图片的base64数据，可以用img标签显示
      },
    });
  });
  wx.error((res) => {
    console.log(JSON.stringify(res) + '微信验证失败');
  });
}

// 获取cdn url
export function getAddress() {
  let cdnUrl = '';
  if ((window.location.port > 3000 || window.location.href.indexOf('exp4pad-test.classba.cn')) !== -1) {
    cdnUrl = 'https://statics.classba.cn/prod/fe_public/';
  } else if (window.location.href.indexOf('exp4pad-pre.classba.cn') > -1) {
    cdnUrl = 'https://statics.classba.cn/pre/fe_public/';
  } else {
    cdnUrl = 'https://statics.classba.cn/prod/fe_public/';
  }
  return {
    yunShangPrivacyAgrement: `${cdnUrl}public/html/activateSimp/yunShangPrivacyAgrement.html?v=20251123`,
    yunShangRegisterAgrement: `${cdnUrl}public/html/activateSimp/yunShangRegisterAgrement.html?v=20251123`,
  };
}
